import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import { alerts } from 'app/components/global';
import topThreats from '../topThreats';
import controller from './edit-top-threats-by-process-dialog.controller';
import template from './edit-top-threats-by-process-dialog.html';


class dialogService {
  getOptions($event, { assessmentId, processes }) {
    return {
      controller,
      controllerAs: 'editTopThreatsByProcessDialogVM',
      locals: {
        assessmentId,
        processes
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editTopThreatsByProcessDialog', [
  alerts,
  bcpDataService,
  constants,
  topThreats,
  loaderService,
  ssDialogService,
])
  .service('editTopThreatsByProcessDialog', dialogService)
  .name;
